import { useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import './ContactForm.css'

export default function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', message: '' })
  const [status, setStatus] = useState('idle') 
  const [serverError, setServerError] = useState('')
  const [captchaToken, setCaptchaToken] = useState(null)
  const [captchaError, setCaptchaError] = useState('')
  const captchaRef = useRef(null)

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }))

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!captchaToken) {
      setCaptchaError('Please verify you are not a robot')
      return
    }
    setCaptchaError('')
    setStatus('sending')
    setServerError('')

    try {
      const res = await fetch(process.env.REACT_APP_PHP_MAIL_SENDER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, captchaToken, formType: 'aselite-contact' }),
      })
      const result = await res.json()

      if (result.success) {
        setStatus('sent')
      } else {
        setStatus('error')
        setServerError(result.message || 'Something went wrong. Please try again.')
      }
    } catch (err) {
      setStatus('error')
      setServerError('Could not reach the server. Please check your connection and try again.')
    } finally {
      captchaRef.current?.reset()
      setCaptchaToken(null)
    }
  }

  if (status === 'sent') {
    return (
      <div className="contact-form-sent">
        <span>✓</span>
        <p>Your message is on its way — check your inbox for a confirmation, and we'll reply shortly.</p>
      </div>
    )
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-field">
        <label htmlFor="c-name">Name</label>
        <input id="c-name" name="name" required value={form.name} onChange={update('name')} placeholder="Your name" autoComplete="name"/>
      </div>
      <div className="form-field">
        <label htmlFor="c-email">Email</label>
        <input id="c-email" name="email" type="email" required value={form.email} onChange={update('email')} placeholder="you@example.com" autoComplete="email" />
      </div>
      <div className="form-field">
        <label htmlFor="c-message">Message</label>
        <textarea id="c-message" name="message" rows="5" required value={form.message} onChange={update('message')} placeholder="How can we help?" autoComplete="off" />
      </div>
      <div className="form-field form-field-captcha">
        <ReCAPTCHA
          ref={captchaRef}
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          theme="dark"
          onChange={(token) => setCaptchaToken(token)}
          onExpired={() => setCaptchaToken(null)}
        />
        {captchaError && <span className="form-error">{captchaError}</span>}
      </div>
      {status === 'error' && <p className="form-error">{serverError}</p>}
      <button type="submit" className="btn btn-primary" disabled={status === 'sending'}>
        {status === 'sending' ? 'Sending…' : 'Send Message'}
      </button>
    </form>
  )
}
